import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import LoadStatus from 'config/load_status';

import useSaveFrom from 'hooks/useSaveFrom';

import loginWithEmailAndPassword, {
  LoginEmailPasswordError,
} from 'domain/authentication/usecases/loginWithEmailAndPassword';

const useLoginPage = () => {
  const from = useSaveFrom('login_from');
  const history = useHistory();

  const [loginForm, setLoginForm] = useState({
    email: '',
    password: '',
  });
  const [loginErrors, setLoginErrors] = useState({
    email: '',
    password: '',
  });
  const [submitStatus, setSubmitStatus] = useState(null);
  const [hasVerifiedEmail, setHasVerifiedEmail] = useState(false);

  useEffect(() => {
    if (submitStatus !== LoadStatus.LOADING) return;

    const postData = async () => {
      try {
        const { email, password } = loginForm;

        setLoginErrors({});
        const emailVerified = await loginWithEmailAndPassword(email, password);

        setHasVerifiedEmail(emailVerified);
        setSubmitStatus(LoadStatus.DONE);
      } catch (error) {
        setSubmitStatus(LoadStatus.ERROR);

        if (error instanceof LoginEmailPasswordError) {
          setLoginErrors({
            email: error.email,
            password: error.password,
          });
          return;
        }

        throw error;
      }
    };
    postData();
  }, [submitStatus, loginForm]);

  const submit = () => {
    if (submitStatus === LoadStatus.LOADING) return;
    if (submitStatus === LoadStatus.DONE) return;

    setSubmitStatus(LoadStatus.LOADING);
  };

  const exitPage = () => history.replace(from);

  return {
    loginForm,
    setLoginForm,
    submit,
    loginErrors,
    isSubmiting: submitStatus === LoadStatus.LOADING,
    hasFinished: submitStatus === LoadStatus.DONE,
    hasVerifiedEmail,
    exitPage,
  };
};

export default useLoginPage;
